import React, { useState } from "react";
import { SearchIcon } from "../Icons/Miscellaneous/SearchIcon";
import { CloseIcon } from "../Icons/Miscellaneous/CloseIcon";
import { useSearchData } from "Hooks/useSearchData";
import { RUTAS } from "rutas";
import { useNavigate } from "react-router-dom";
import "./SearchModal.scss";

/**
 * Modal de busqueda
 *
 * @param {Object} props - Propiedades del componente
 * @param {boolean} [props.isOpen=false] - Controla si el modal está visible o oculto
 * @param {Function} props.onClose - Función que se ejecuta para cerrar el modal
 * @param {string} [props.className=''] - Clases CSS adicionales para personalizar el estilo
 */
export const SearchModal = ({
  isOpen = false,
  onClose,
  className = "",
  ...props
}) => {
  const [searchValue, setSearchValue] = useState("");
  const { busquedas, isLoading } = useSearchData();
  const navigate = useNavigate();

  const normalizeText = (text) => {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const filteredResults = searchValue
    ? busquedas.filter((cursoPaquete) => {
        const normalizedSearch = normalizeText(searchValue);
        const normalizedTitle = normalizeText(cursoPaquete.titulo);
        const normalizedCategory = normalizeText(cursoPaquete.categoria);
        const normalizedType = normalizeText(cursoPaquete.tipoAprendizaje);
        const normalizedTags = normalizeText(cursoPaquete.etiquetas || "");

        return (
          normalizedTitle.includes(normalizedSearch) ||
          normalizedCategory.includes(normalizedSearch) ||
          normalizedType.includes(normalizedSearch) ||
          normalizedTags.includes(normalizedSearch)
        );
      })
    : [];

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleClose = () => {
    setSearchValue("");
    onClose?.();
  };

  const handleResultClick = (cursoPaquete) => {
    handleClose();
    const path =
      cursoPaquete.idTipoAprendizaje === 1
        ? RUTAS.CURSO(cursoPaquete.id)
        : RUTAS.PAQUETE(cursoPaquete.id);
    navigate(path);
  };

  if (!isOpen) return null;

  return (
    <div className={`search-modal ${className}`} {...props}>
      <div className="search-modal__input-container">
        <div className="search-modal__input-wrapper">
          <SearchIcon />
          <input
            type="text"
            id="search-input"
            name="search"
            value={searchValue}
            onChange={handleInputChange}
            placeholder="Buscar..."
            className="search-modal__input"
            disabled={isLoading}
            autoFocus
          />
        </div>

        <button onClick={handleClose} className="search-modal__close-btn">
          <CloseIcon />
        </button>
      </div>

      {searchValue && !isLoading && (
        <div className="search-modal__results">
          {filteredResults.length > 0 ? (
            filteredResults.map((cursoPaquete) => (
              <div
                key={cursoPaquete.idAlterno}
                className="search-modal__result-item"
                onClick={() => handleResultClick(cursoPaquete)}
              >
                <h3
                  className="search-modal__result-title"
                  title={cursoPaquete.titulo}
                >
                  {cursoPaquete.titulo}
                </h3>
                <p
                  className="search-modal__result-subtitle"
                  title={`${cursoPaquete.categoria} - ${cursoPaquete.tipoAprendizaje}`}
                >
                  {cursoPaquete.categoria} - {cursoPaquete.tipoAprendizaje}
                </p>
              </div>
            ))
          ) : (
            <div className="search-modal__no-results">
              <p>No se encontraron resultados para "{searchValue}"</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
